import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import FormDetails from "./containers/details"
import FormsListing from "./containers/listing"
import { FormsContext } from "./context"
import "./styles.scss"
import { TForms } from "./types"

export default function Forms({ }: TForms) {

    return <ContentSectionContainer className="formsContainer">
        <FormsContext.Provider value={{}}>
            <Routes>

                <Route index path={fetchRoute({ route: ERoutes.forms })} element={<FormsListing />} />
                <Route path={fetchRoute({ route: ERoutes.formDetails })} element={<FormDetails />} />
                <Route path={fetchRoute({ route: ERoutes.formEdit })} element={<FormDetails />} />
                <Route index path={fetchRoute({ route: ERoutes.legacyForms })} element={<FormsListing key="legacy" legacy={true} />} />

                <Route index path={"/"} element={<FormsListing />} />
                <Route index path={"/basic"} element={<FormsListing key="legacy" legacy={true} />} />
                <Route index path={"/:formId"} element={<FormDetails />} />
                <Route index path={"/:formId/edit"} element={<FormDetails />} />

            </Routes>
        </FormsContext.Provider>
    </ContentSectionContainer >
}   